import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { RouterProvider } from "react-router-dom";

//import Acessos from "./pages/Acessos";
import L from "leaflet";
//import CriaUsuario from "./pages/criaUsuario";
//import Empresas from "./pages/empresas";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Button, CssBaseline } from "@mui/material";
//import HostsEasyAdd from "./pages/easyAdd/paginaInicial";
import foto from "./assets/fullscreen.png";

import { myTheme } from "./themes";
import { socketCliente } from "./services/socket";
// import NovoRelatorio from "./pages/easyReport/relatorios/novoRelatorio";
import {
  NotificationProvider,
  useNotification,
} from "./componentes/notificationProvider";
import api from "./services/api";
import routers from "./routers";
import SocketNotification from "./componentes/socketNotification";
import { notifyOnPage } from "./utils/notifyOnPage";
import { ErrorBoundary } from "react-error-boundary";
import ErrorMessageGeral from "./componentes/errorMessage";

function App() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [checkLogin, setCheckLogin] = useState(null);
  const [colorMode, setColorMode] = useState(prefersDarkMode);
  // const [isConnected, setIsConnected] = useState(socket.connected);
  const [isConnectedCliente, setIsConnectedCliente] = useState(
    socketCliente.connected,
  );
  const [modulos, setModulos] = useState(null);
  const [modulosError, setModulosError] = useState(null);

  useEffect(() => {
    setColorMode(prefersDarkMode);
  }, [prefersDarkMode]);

  useEffect(() => {
    // handleApiGetModules();
    let colorModeStorage = JSON.parse(localStorage.getItem("theme"));
    if (colorModeStorage) {
      setColorMode(colorModeStorage.colorMode);
    }
  }, []);

  useEffect(() => {
    function onConnectCliente() {
      setIsConnectedCliente(true);

      socketCliente.emit(
        "first_connection",
        `Frontend cliente estabeleceu conexão, id conection: ${socketCliente.id}`,
      );
    }
    // function onConnect() {
    //   setIsConnected(true);
    //   socket.emit(
    //     "first_connection",
    //     `Frontend cliente estabeleceu conexão, id conection: ${socket.id}`
    //   );
    // }
    // function onDisconnect() {
    //   setIsConnected(false);
    // }
    function onDisconnectCliente() {
      setIsConnectedCliente(false);
    }

    function connectErrorEvent(error) {
      notifyOnPage(
        "/easyMaps/mapa/geo",
        <>
          Falha de socket, favor{" "}
          <Button
            sx={{ paddingX: 0 }}
            color="error"
            onClick={() => window.location.reload()}
          >
            atualize a pagina
          </Button>
        </>,
        "error",
        null,
      );
      console.log("Socket error - erro de conexão:", error);
    }
    function connectErrorEventInterno(error) {
      console.log("Socket error - erro de conexão:", error);
    }
    function reconnectAttemptEvent(attempt) {
      console.log(
        `Socket warn - o servido esta tentando ser reconectar. N de tentativas: ${attempt}`,
      );
    }
    function reconnectErrorEvent(error) {
      console.log("Socket error - erro de reeconexão:", error);
    }
    function reconnectEvent(attempt) {
      console.log("Socket success: servidor reeconectado com sucesso");
    }
    if (!checkLogin) {
      // if (isConnected) socket.disconnect();
      if (isConnectedCliente) socketCliente.disconnect();
    }

    if (checkLogin) {
      //atualiza query socketCliente para enviar id do usuarioCliente
      socketCliente.io.opts.query = {
        usuarioClienteId: JSON.parse(localStorage.getItem("1"))?.usuarioCliente
          ?.id,
      };
      socketCliente.connect();
      // socket.connect();

      socketCliente.on("connect", onConnectCliente);
      socketCliente.on("disconnect", onDisconnectCliente);
      socketCliente.on("connect_error", connectErrorEvent);
      socketCliente.io.on("reconnect_attempt", reconnectAttemptEvent);
      socketCliente.io.on("reconnect_error", reconnectErrorEvent);
      socketCliente.io.on("reconnect", reconnectEvent);

      // socket.on("connect", onConnect);
      // socket.on("disconnect", onDisconnect);
      // socket.on("connect_error", connectErrorEventInterno);
      // socket.io.on("reconnect_attempt", reconnectAttemptEvent);
      // socket.io.on("reconnect_error", reconnectErrorEvent);
      // socket.io.on("reconnect", reconnectEvent);
      return () => {
        socketCliente.off("connect", onConnectCliente);
        // socketCliente.off("disconnect", onDisconnect);
        socketCliente.off("connect_error", connectErrorEvent);
        socketCliente.io.off("reconnect_attempt", reconnectAttemptEvent);
        socketCliente.io.off("reconnect_error", reconnectErrorEvent);
        socketCliente.io.off("reconnect", reconnectEvent);

        // socket.off("connect", onConnect);
        // socket.off("disconnect", onDisconnect);
        // socket.off("connect_error", connectErrorEventInterno);
        // socket.io.off("reconnect_attempt", reconnectAttemptEvent);
        // socket.io.off("reconnect_error", reconnectErrorEvent);
        // socket.io.off("reconnect", reconnectEvent);
      };
    }
  }, [checkLogin]);

  // function conectarSocket() {
  //   const usuarioClienteId = JSON.parse(localStorage.getItem("1"))?.usuarioCliente?.id;
  //   if (usuarioClienteId) {
  //     socketCliente.io.opts.query = { usuarioClienteId };
  //     socketCliente.connect();
  //   } else {
  //     console.error("ID do usuário não encontrado no localStorage");
  //   }
  // }
  useEffect(() => {
    const fullscreenStyle = `
    .custom-tooltip{
      background-color: rgba(255,255,255,0.7);
      border: none;
    }
    .leaflet-interactive{
      outline:none
    }

    .leaflet-touch .leaflet-control-fullscreen a {
      background-position: 2px 2px;
    }
    .leaflet-fullscreen-on .leaflet-control-fullscreen a {
      background-position:0 -26px;
    }
    .leaflet-touch.leaflet-fullscreen-on .leaflet-control-fullscreen a {
      background-position: 2px -24px;
    }
  
    /* Do not combine these two rules; IE will break. */
    .leaflet-container:-webkit-full-screen {
      width:100%!important;
      height:100%!important;
    }
    .leaflet-container.leaflet-fullscreen-on {
      width:100%!important;
      height:100%!important;
    }
  
    .leaflet-pseudo-fullscreen {
      position:fixed!important;
      width:100%!important;
      height:100%!important;
      top:0!important;
      left:0!important;
      z-index:99999;
    }
  
    @media
      (-webkit-min-device-pixel-ratio:2),
      (min-resolution:192dpi) {
        .leaflet-control-fullscreen a {
          background-image:url(fullscreen@2x.png);
        }
    }`;
    const styleUnique = `
    
       .leaflet-container {
      background-color: transparent!important; /* Cor de fundo inicial */
      transition: background-color 0.3s ease; /* Transição suave */
    }
    .leaflet-container.tiles-loaded {
      background-color:transparent!important; /* Cor de fundo quando os tiles forem carregados */
    }

    .leaflet-bottom {
      bottom: 0;
      display: none;
    }
      .toast-progress-neutral {
  background: #ff8f8fff !important;
}
    .leaflet-marker-icon.easymaps-textbox {
      background: transparent !important;
      border: none !important;
      width: auto !important;
      height: auto !important;
    }
    `;
    // Cria a folha de estilo embutida para aplicar o filtro ao Leaflet
    const style =
      (colorMode
        ? `
      .leaflet-layer,
      .leaflet-control-zoom-in,
      .leaflet-control-zoom-out,
      .leaflet-control-attribution {
        filter: invert(100%) hue-rotate(180deg) brightness(60%) contrast(95%) sepia(20%) grayscale(30%);
        //filter: invert(100%) hue-rotate(180deg) brightness(100%) contrast(85%) ;
      }
      .leaflet-control-fullscreen a {
        filter: invert(100%);
        background:${"#f2f2f2"} url(${foto}) no-repeat 0 0;
       
        background-size:26px 52px;
      }
      .leaflet-div-icon {
        border: none!important;
        background: transparent!important;
   
      }
      .leaflet-tooltip {
        background-color:#3d3d3d;
        border: 0px;
        box-shadow: none;
    }
  
    .leaflet-tooltip-top:before {
      
      margin-top: -12px;
      border-top-color:#3d3d3d;
    
      }`
        : ` 
        .leaflet-layer,
      .leaflet-control-attribution {
        //filter: invert(100%) hue-rotate(180deg) brightness(60%) contrast(95%) sepia(20%) grayscale(30%);
        filter:  grayscale(60%) sepia(5%)  ;
      }
    .leaflet-tooltip {
      
      border: 0px;
      box-shadow: none;
  }
    .leaflet-control-fullscreen a {
      background:${"#fff"} url(${foto}) no-repeat 0 0;
      background-size:26px 52px;
    }
    .leaflet-div-icon {
      border: none!important;
      background: transparent!important;
    }`) +
      fullscreenStyle +
      styleUnique;

    const styleElement = L.DomUtil.create("style", "leaflet-custom-style");

    styleElement.type = "text/css";
    if (styleElement.styleSheet) {
      styleElement.styleSheet.cssText = style;
    } else {
      styleElement.appendChild(document.createTextNode(style));
    }

    document.getElementsByTagName("head")[0].appendChild(styleElement);

    // Remove a folha de estilo embutida quando o componente é desmontado
    return () => {
      document.getElementsByTagName("head")[0].removeChild(styleElement);
    };
  }, [colorMode]);

  useEffect(() => {
    // Define o estilo a ser aplicado com base no modo de cor
    const style = colorMode
      ? `::-webkit-scrollbar-track {
        background: #1E1E1E; 
      }
      ::-webkit-scrollbar-thumb {
        background: #555;
      }
      ::-webkit-scrollbar {
        width: 10px; 
        height:10px
      }
        ::-webkit-scrollbar-thumb:hover {
          background: #474747;
        }
     `
      : `::-webkit-scrollbar-track {
        background: #e2e2e2;
      }
      ::-webkit-scrollbar-thumb {
        background: #b3b3b3; 
        }

     ::-webkit-scrollbar-thumb:hover {
           background: #8f8e8e; 
       
      }
      ::-webkit-scrollbar {
        width: 10px;
        height:10px
       
      }`;

    // Cria o elemento <style> e adiciona o CSS
    const styleElement = document.createElement("style");
    styleElement.type = "text/css";

    // Verifica compatibilidade para inserir o CSS
    if (styleElement.styleSheet) {
      styleElement.styleSheet.cssText = style;
    } else {
      styleElement.appendChild(document.createTextNode(style));
    }
    // Adiciona o elemento <style> ao <head> do documento
    document.head.appendChild(styleElement);
    // Remove o estilo ao desmontar o componente
    return () => {
      document.head.removeChild(styleElement);
    };
  }, [colorMode]);
  //
  const theme = React.useMemo(() => myTheme(colorMode), [colorMode]);

  // async function handleApiGetModules(params) {
  //   try {
  //     const response = await api.post("/modulo/cliente/find");

  //     if (response.data) {
  //       console.log(response.data);
  //       setModulos(response.data);
  //     }
  //   } catch (error) {
  //     console.log(error?.response?.data?.error);
  //     setModulos("");
  //     setModulosError(
  //       error?.response?.data?.error || error?.response?.data || error?.response
  //     );
  //     console.error(error);
  //   }
  // }
  // Configuração do router

  const router = routers({
    // socket,
    socketCliente,
    setCheckLogin,
    checkLogin,
    setColorMode,
    colorMode,
  });

  return (
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <SocketNotification />
        <CssBaseline />
        <ErrorBoundary
          FallbackComponent={() => (
            <ErrorMessageGeral
              message={"Algo deu errado ao carregar o sistema"}
            />
          )}
        >
          <div className="App">
            <RouterProvider router={router} />
          </div>
        </ErrorBoundary>
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
